import { render, staticRenderFns } from "./RenovationsTable.vue?vue&type=template&id=0d9876b4&scoped=true&"
import script from "./RenovationsTable.vue?vue&type=script&lang=js&"
export * from "./RenovationsTable.vue?vue&type=script&lang=js&"
import style0 from "./RenovationsTable.vue?vue&type=style&index=0&id=0d9876b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9876b4",
  null
  
)

export default component.exports